<template>
  <ModelManagerPage
          lower-app-name="emarket"
          lower-model-name="order"
          version="2"
          obj-label="订单">
  </ModelManagerPage>
</template>

<script>
import ModelManagerPage from './ModelManagerPage.vue'

export default {
  name: 'OrderManager',
  props: {
  },
  components: {
    ModelManagerPage
  },
  data: function () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// OrderManager.vue?4406bf0a